<script setup lang="ts">
import { computed } from 'vue'

import clsx from 'clsx'

import BetaBaseImage from '@/components/beta-editor/BetaBaseImage.vue'
import { useEditorBetaStore } from '@/stores/editor/beta'

const props = defineProps<{
    element: any
    extra: any
    elementIndex: number
    isFull: boolean
    isNew?: boolean
    schema?: any
}>()

const betaStore = useEditorBetaStore()
const elementId = computed(() => betaStore.getElementId(props.element))
const isActive = computed(() => betaStore.isElementActive(elementId.value))
const content = computed(() => props.element.frameContent ?? {})
const hasExtra = computed(() => props.extra != null)

const dynamicStyle = computed(() => {
    if (!hasExtra.value) return undefined

    const style: Record<string, string> = {
        margin: `${props.extra.margin?.top ?? 0}px ${props.extra.margin?.right ?? 0}px ${props.extra.margin?.bottom ?? 0}px ${props.extra.margin?.left ?? 0}px`,
        padding: `${props.extra.padding?.top ?? 0}px ${props.extra.padding?.right ?? 0}px ${props.extra.padding?.bottom ?? 0}px ${props.extra.padding?.left ?? 0}px`,
    }

    if (!props.extra.style_width_lock) style.width = props.extra.style?.width
    if (!props.extra.style_height_lock) style.height = props.extra.style?.height

    return style
})
</script>

<template>
    <div
        tabindex="0"
        :id="'betaEditorVideo-' + elementIndex"
        :data-active="isActive"
        :style="dynamicStyle"
        :schema="JSON.stringify(schema)"
        :class="clsx('editor-video-beta', isFull && 'video-full')"
    >
        <div class="relative h-full w-full">
            <svg
                class="absolute left-1/2 top-1/2 z-10 h-1/3 w-1/3 -translate-x-1/2 -translate-y-1/2 fill-white drop-shadow-md"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke-width="1.5"
            >
                <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
            </svg>

            <beta-base-image class-name="h-full w-full object-cover" :src="content.thumbnail" />
        </div>
    </div>
</template>

<style scoped>
.editor-video-beta {
    @apply relative flex border-2 border-transparent bg-transparent outline-none transition-all duration-1000 ease-in-out hover:border-[#D7E3F4] hover:shadow-[0_0_0_2px_rgba(215,227,244,0.22)];
}

.editor-video-beta[data-active='true'] {
    @apply border-[#8EB3E8] shadow-[0_0_0_3px_rgba(142,179,232,0.24)];
}

.editor-video-beta.video-full :deep(img) {
    @apply w-[100vw] max-w-[unset];
}
</style>
